import { exec } from "@kakaopay-common/payweb-core";
import { Browser } from "@kakaopay-common/user-agent";
import { INTERFACE, NONE_INDENTIFIER } from "../../constants.mjs";
import { appendTiaraReferrer } from "../../utils/appendTiaraReferrer.mjs";
import { checkNativeStorageVersion } from "../../utils/checkVersion.mjs";
import { isUndefined } from "../../utils/isUndefined.mjs";
import { getStorageItem } from "../Storage/getStorageItem.mjs";
import { setStorageItem } from "../Storage/setStorageItem.mjs";
import { CLOSE_MODE } from "./closeEvent.mjs";
const LAST_COMMON_NEED_POSSESSION_TIMESTAMP = "last_common_need_possession_timestamp";
async function openPayweb(url, {
  with_tiara_referrer,
  has_close,
  color_scheme,
  bg_color,
  view_mode,
  post_body,
  navigation,
  hidden,
  subsidiary_name,
  subsidiary_logo,
  need_possession,
  tiara,
  version
} = {}) {
  const revisedUrl = with_tiara_referrer ? appendTiaraReferrer(url) : url;
  if (!Browser.isPayWebview()) {
    console.warn("[openPayweb] it is not payweb. it will open with window.open()");
    window.open(revisedUrl);
    return new Promise((resolve) => {
      window.KakaoPay.sendData = (data) => {
        resolve({
          command: INTERFACE.PAYWEB,
          success: true,
          result: {
            data
          },
          extras: {
            identifier: NONE_INDENTIFIER
          }
        });
      };
    });
  }
  if (need_possession && window.__POSSESSION_TIMEOUT__ && checkNativeStorageVersion()) {
    try {
      const res = await getStorageItem(LAST_COMMON_NEED_POSSESSION_TIMESTAMP);
      if (res.success && res.result.value) {
        const diff = (/* @__PURE__ */ new Date()).getTime() - Number(res.result.value);
        if (diff < window.__POSSESSION_TIMEOUT__) {
          need_possession = void 0;
          console.log("[payweb] possession is in valid time. skip possession.");
        }
      }
      await setStorageItem(LAST_COMMON_NEED_POSSESSION_TIMESTAMP, String((/* @__PURE__ */ new Date()).getTime()));
    } catch (e) {
      console.warn("get_storage_item has occured an error.");
    }
  }
  const command = {
    command: INTERFACE.PAYWEB,
    parameters: {
      url: revisedUrl,
      ...has_close && { close_type: CLOSE_MODE.CLOSE },
      ...!isUndefined(color_scheme) && { color_scheme },
      ...!isUndefined(bg_color) && { bg_color },
      ...!isUndefined(view_mode) && { view_mode },
      ...!isUndefined(post_body) && { post_body },
      ...!isUndefined(navigation) && { navigation },
      ...!isUndefined(view_mode) && { view_mode },
      ...!isUndefined(subsidiary_name) && { subsidiary_name },
      ...!isUndefined(subsidiary_logo) && { subsidiary_logo },
      ...!isUndefined(hidden) && { hidden },
      ...!isUndefined(need_possession) && { need_possession }
    },
    extras: {
      ...!isUndefined(tiara) && { tiara }
    },
    ...!isUndefined(version) && { version }
  };
  return exec(command);
}
export {
  openPayweb
};
